<template>
    <div>
        <b-row>
            <b-col md="12" class="mb-4">
                <h6>Null</h6>
                <country-selectbox v-model="value1" :public="true"/>
                <span>{{ value1 }}</span>
            </b-col>
            <b-col md="12" class="mb-4">
                <h6>Single Selected</h6>
                <country-selectbox v-model="value2" :public="true"/>
                <span>{{ value2 }}</span>
            </b-col>
            <b-col md="12" class="mb-4">
                <h6>Multiple Selected</h6>
                <country-selectbox v-model="value3" :multiple="true" :public="true"/>
                <span>{{ value3 }}</span>
            </b-col>
            <b-col md="12" class="mb-4">
                <h6>Value Type - Code</h6>
                <country-selectbox v-model="value4" value-type="code" :public="true"/>
                <span>{{ value4 }}</span>
            </b-col>
            <b-col md="12" class="mb-4">
                <h6>Validate Error</h6>
                <country-selectbox v-model="value5" :validateError="value5ValidateError" :public="true"/>
                <span>{{ value5 }}</span>
            </b-col>
            <b-col cols="12">
                <b-button variant="primary" @click="change()">
                    {{ $t('change').toUpper() }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import CountrySelectbox from '@/components/interactive-fields/CountrySelectbox';

    export default {
        components: {
            CountrySelectbox
        },
        data() {
            return {
                value1: null,
                value2: 178,
                value3: [178],
                value4: 'US',
                value5: 178,
                value5ValidateError: 'Validate Error is Working'
            }
        },
        methods: {
            change() {
                this.value2 = 171
                this.value3 = [178, 171]
                this.value4 = 'TR'
                this.value5 = 171
                this.value5ValidateError = 'Error'
            }
        }
    };
</script>

